import question from "@assets/question.svg";
import Combatant from "@/encounter/model/Combatant.ts";
import {srcUrl} from "@/api/ImageApi.ts";

interface CharacterAvatarProps {
    combatant: Combatant,
    size: number,
    className?: string,
}

export default function CharacterAvatar(
    {
        combatant,
        size,
        className,
    }: CharacterAvatarProps) {

    return (
        <div
            className={`${className} relative bg-white select-none overflow-hidden`}
            style={{width: size, height: size, minWidth: size}}>
            {combatant.character.image &&
                <img draggable="false" alt="" className="absolute select-none"
                     src={srcUrl(combatant.character.image)}
                     style={{
                         maxWidth: 2 * size,
                         height: size,
                         left: '50%',
                         top: '50%',
                         transform: 'translate(-50%, -50%)'
                     }}
                />}
            {!combatant.character.image &&
                <img width={size} height={size} draggable="false"
                     className={"absolute size-full scale-90 inset-0"}
                     src={question} alt=""/>
            }

        </div>
    )
}